import React, { useState } from "react";
import { Modal } from "react-bootstrap";
import { message } from "antd";
import Instance from "../../AxiosConfig";
import { Spin } from "antd";

const AddStandardModal = ({ show, handleClose, fetchData }) => {
  const [name, setName] = useState("");
  const [description,setDescription]=useState("");
  const [loading, setLoading] = useState(false);
  const handleSave = async () => {
    try {
      setLoading(true);
      // const token = localStorage.getItem("token");  

      const response = await Instance.post("/standards", {
        standardName: name,
        description: description,
      });
      console.log(response);
      // ✅ Show success message if API call succeeds
      if (response.status == 200 || response.status == 201) {
        message.open({
          type: "success",
          content: "New Standard added successfully!",
          className: "custom-add-agent-toast",
        });
        handleClose();
        setName("");
        setDescription("");
        fetchData();  
      }
      setLoading(false);
    } catch (error) {
      console.error("Error adding standard:", error);
      message.error("Failed to add standard. Please try again.");
      setLoading(false);
    } finally {
      setLoading(false);
    }
  };

  return (
    <Modal
      show={show}
      onHide={handleClose}
      width="700px"
      centered
      backdrop="static"
      dialogClassName="custom-agent-modal"
    >
      <Modal.Header closeButton>
        <Modal.Title>Add New Standard</Modal.Title>
      </Modal.Header>

      <Modal.Body>
        <form>
          <div className="container-fluid">
            <div className="row">
              <div className="col-md-12 mb-3">
                <label className="form-label">Standard Name</label>
                <input
                  type="text"
                  value={name}
                  onChange={(e) => setName(e.target.value)} // ✅ Controlled input
                  className="form-control"
                  placeholder="Enter standard name"
                />
              </div>

              <div className="col-md-12 mb-3">
                <label className="form-label">Description</label>
                <textarea
                  className="form-control"
                  placeholder="Enter description"
                  value={description}
                  onChange={(e) => setDescription(e.target.value)} 
                  rows={4}
                ></textarea>
              </div>

              <div className="d-flex justify-content-end gap-2 mt-3">
                <button
                  type="button"
                  className="users-discard-button"
                  onClick={handleClose}
                >
                  Discard
                </button>
                <button
                  type="button"
                  className="users-save-button d-flex align-items-center justify-content-center"
                  onClick={handleSave}
                  disabled={loading}  
                  style={{ minWidth: "100px" }}
                >
                  {loading ? (
                    <>
                      <Spin size="small" /> &nbsp;Saving...
                    </>
                  ) : (
                    "Save"
                  )}
                </button>
              </div>
            </div>
          </div>
        </form>
      </Modal.Body>
    </Modal>
  );
};

export default AddStandardModal;
